import * as React from 'react';

import { useSetAtom } from 'jotai';

import { $populateScaleFormAction } from '../_state/scaleForm.state';
import { ScaleDetailRecord } from '../types/sidecar';

type Props = {
  scale: ScaleDetailRecord | null | undefined;
};

export const usePopulateScaleForm = ({ scale }: Props) => {
  const populateForm = useSetAtom($populateScaleFormAction);

  React.useEffect(() => {
    populateForm(scale);
  }, [scale, populateForm]);
};
